export const copy = {
  bookend: {
    started: "Chat started",
  },
  event: {
    agent: {
      join: (name: string) => `${name} has joined the chat`,
      leave: (name: string) => `${name} has left the chat`,
    },
  },
  message: {
    ariaLabel: (name: string, createdTime: string) =>
      `Sent by ${name} on ${createdTime}`,
  },
  isTyping: (name: string) => `${name} is typing...`,
};
